import {useRef} from 'react';
import Nav from './Nav';
import Hero from './Hero'
import MainChapters from './MainChapters';
import Footer from './Footer';

export default function Home() {
  const lists = useRef();

  document.title = "Arisu";

  function scrollToLists() {
    lists.current.scrollIntoView({behavior: "smooth"});
  }

  return (
    <>
      <Nav />
      <Hero action={scrollToLists}/>
      <MainChapters location={lists}/>
      <Footer />
    </>
  )
}